import { getRegisteredModule } from '@ICube/icube-core';

export const defaultLazyHtmlConfig = {
    exceptionClass: 'ci-body-loader',
    onInit: function($el) {
        const BodyLoader = getRegisteredModule('BodyLoader');
        const newLazyLoadHtmlIndex = ICube.data.get('lazyLoadHtmlIndex') + 1;
        const loader = new BodyLoader(Object.assign({}, ICube.data.get('defaultBodyLoaderConfig'), {
            id: 'ci-lazy-html-loader-' + newLazyLoadHtmlIndex,
            resizeToParent: true,
            bodyLock: false,
            imageSrc: `${ICUBE_CONFIG.static_domain}assets/publicarea/images/tail-spin.svg`
        }));

        loader.init();
        ICube.data.set('lazyLoadHtmlIndex', newLazyLoadHtmlIndex);
        $el.prepend(loader.$loader);
        $el.loader = loader;
    },
    beforeRequest: function($el) {
        $el.loader.show();
    },
    afterRender: function($el) {
        $el.loader.hide();
    }
}